import { render, staticRenderFns } from "./ResourceCalendar.vue?vue&type=template&id=0f96e64e"
import script from "./ResourceCalendar.vue?vue&type=script&lang=js"
export * from "./ResourceCalendar.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendar.vue?vue&type=style&index=0&id=0f96e64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports